function trackMessageFromExistingUser(location: string) {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveySignupExistingUser',
    data: {
      location,
    },
  });
}

export default trackMessageFromExistingUser;
